// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy                 from 'fg-frontend/components/CookiesPolicy4/index';
import phoneLink                     from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
//import('./components/plUpload/fg.upload');                // PL upload
//import 'bootstrap/js/dist/collapse';

var enableOneGTMContainer = true;

const bodyElement = document.getElementById("top");
if (bodyElement.classList.contains('wikov')) {
    enableOneGTMContainer = false;
}

if (!bodyElement.classList.contains('zbecnik2023') && !bodyElement.classList.contains('wikovjp')) {
    cookiesPolicy({
        enableImg: false,
        enableOneGTMContainer: enableOneGTMContainer,
    });
}

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();

// Nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/configureWeb.js